var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.items.length && !_vm.isWindowSmall
        ? _c(
            "ul",
            { staticClass: "tabs" },
            _vm._l(_vm.items, function(item, index) {
              return _c(
                "li",
                {
                  key: index,
                  staticClass: "tabs__item",
                  class: { "tabs__item--inactive": !item.isActive }
                },
                [
                  _c(
                    "router-link",
                    {
                      staticClass: "tabs__link",
                      class: { "tabs__link--active": item.isActive },
                      attrs: { to: item.to, replace: "" }
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "tabs__link-inner",
                          class: { "tabs__link-inner--first": index === 0 }
                        },
                        [_vm._v(_vm._s(item.label))]
                      )
                    ]
                  )
                ],
                1
              )
            })
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.items.length && _vm.isWindowSmall
        ? _c(
            "dropdownComponent",
            {
              directives: [
                {
                  name: "on-click-outside",
                  rawName: "v-on-click-outside",
                  value: _vm.closeSegmentDropDown,
                  expression: "closeSegmentDropDown"
                }
              ],
              staticClass: "dropdown",
              attrs: { open: _vm.isDropdownOpen }
            },
            [
              _c("div", { attrs: { slot: "trigger" }, slot: "trigger" }, [
                _c("span", { on: { click: _vm.onClickDropdown } }, [
                  _c("span", { staticClass: "dropdown__current-option" }, [
                    _vm._v(_vm._s(_vm.activeItem.label))
                  ])
                ]),
                _vm._v(" "),
                _vm.defaultItem &&
                _vm.activeItem.label !== _vm.defaultItem.label
                  ? _c("span", {
                      staticClass: "icon-cancel dropdown-cancel",
                      on: { click: _vm.resetDropDown }
                    })
                  : _c("span", {
                      staticClass: "icon-chevron-lg-down",
                      on: { click: _vm.onClickDropdown }
                    })
              ]),
              _vm._v(" "),
              _c(
                "ul",
                { attrs: { slot: "option" }, slot: "option" },
                _vm._l(_vm.items, function(item, index) {
                  return _c(
                    "li",
                    {
                      key: index,
                      staticClass: "dropdown__option-wrapper",
                      class: {
                        "dropdown__option-wrapper--active":
                          item.label === item.isActive
                      }
                    },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "dropdown__option",
                          attrs: { to: item.to },
                          nativeOn: {
                            click: function($event) {
                              return _vm.onClickDropdown($event)
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(item.label) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                })
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }